import { graphqlClient } from "../../../client";
import getOrganizationDataQuery from "./getOrganizationData.graphql";

export type OrganizationDetails = {
  organizationId: string;
  companyName: string;
  description: string;
  vatNumber: string;
  country: string;
  status: string;
  hasSeenProductOnboarding: boolean;
};

export async function getOrganizationData(organizationId: string): Promise<OrganizationDetails | null> {
  const { data } = await graphqlClient.query<{ getOrganizationData: OrganizationDetails | null }>({
    query: getOrganizationDataQuery,
    variables: { organizationId },
  });

  return data.getOrganizationData ?? null;
}
